import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import SectionContainer from '../SectionContainer';
import SectionTitle from '../SectionTitle';
import SectionText from '../SectionText';
import ClientToolsTable from './ClientToolsTable';
import { device } from '../../../../style/Sizes';
import { AbcText } from './AllSectionTexts';
import ScrollToTop from '../../../../hoc/ScrollToTop';
import Footer from '../../../Footer/Footer';
import { ButtonNoBorder } from '../../../UI/Button/Button';

const Container = styled.div`
  width: 100%;
  height: auto;
  /* background: red; */
  text-align: center;
`;

const FirstSectionContainer = styled.div`
  position: relative;
  margin: 150px auto 72px auto;
  max-width: 1000px;
  padding-bottom: 0;
  background-color: #f5f5f5;
  /* background-color: #e6e9ea; */
  /* background-color: #C0C8CB; */
  /* background: gainsboro; */

  @media ${device.maxTablet} {
    padding-bottom: 32px;
  }
`;

const TitleContainer = styled.div`
  position: relative;
  float: left;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -47%);
  z-index: 2;
`;

const Title = styled.div`
  font-family: miller-display, serif;
  font-weight: 600;
  font-style: normal;
  font-size: 79px;
  /* letter-spacing: -0.5px; */
`;

const SubTitle = styled.div`
  font-family: miller-headline, serif;
  font-weight: 700;
  font-style: italic;
  font-size: 19px;
  letter-spacing: 0.8px;
`;

const StyledP = styled.p`
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 17px;
  text-align: center;
  margin-bottom: 100px;
`;

// const Role = 'My Role';

const AbcContainer = () => {
  const [desktop, setDesktop] = useState();
  // const [clHeight, setClHeight] = useState();
  const [clWidth, setClWidth] = useState();

  const checkDesktop = () => {
    window.matchMedia('(min-width: 768px)').matches
      ? setDesktop(true)
      : setDesktop(false);
    // setClHeight(document.documentElement.clientHeight);
    setClWidth(document.documentElement.clientWidth);
  };

  useEffect(() => {
    checkDesktop();
  });

  useEffect(() => {
    window.addEventListener('resize', checkDesktop);
    return () => {
      window.removeEventListener('resize', checkDesktop);
    };
  });

  return (
    <ScrollToTop>
      <Container>
        <FirstSectionContainer clWidth={clWidth}>
          <TitleContainer>
            <Title>&nbsp;</Title>
            <SubTitle>Rethinking digital banking products</SubTitle>
          </TitleContainer>
          <SectionContainer
            noTransition
            containerMarginBottom={'100px'}
            src={require('../../../../assets/images/AbcLogo.png')}
            alt="Logo"
            // imgContainerHeight={'94vw'}
            imgContainerHeight={'60vw'}
            imgContainerMaxHeight={'600px'}
            imgContainerMinHeight={''}
            imgHeight={'12%'}
            imgMarginTop={clWidth < 515 ? '80px' : '16%'}
          />
          <ClientToolsTable desktop={desktop} />
        </FirstSectionContainer>
        <SectionTitle
          sectionTitle={AbcText.AboutAbc}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={AbcText.AboutAbcText}
          textMarginBottom={'default'}
        />
        <SectionTitle
          sectionTitle={AbcText.TheChallenge}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={AbcText.TheChallengeText}
          textMarginBottom={'default'}
        />
        <SectionTitle
          sectionTitle={AbcText.MyRole}
          titleMarginBottom={'default'}
        />
        <SectionText
          sectionText={AbcText.MyRoleText}
          textMarginBottom={'37px'}
        />
        <StyledP>
          Visit &nbsp;
          <ButtonNoBorder href="https://www.abcfinlab.de" title="abcfinlab">
            abcfinlab
          </ButtonNoBorder>
        </StyledP>
      </Container>
      <Footer />
    </ScrollToTop>
  );
};

export default AbcContainer;
